import { Stack, Text } from '@veeqo/ui';
import { ContentStyle, copy } from 'components/Landing/content';
import { useTranslation } from 'context/TranslationContext';

export const VeeqoInlineSubtitle = ({ contentStyle }: { contentStyle: ContentStyle }) => {
  const { t } = useTranslation();
  return (
    <Stack direction="vertical" alignX="center">
      <Text variant="headingLarge" style={{ textAlign: 'center' }}>
        {t(copy[contentStyle].inlineSubtitleTextId)}
      </Text>
    </Stack>
  );
};
